import { createContext } from 'react';

const QuestionIdContext = createContext();

export default QuestionIdContext;
